/**
 * App - Root React component orchestrating all pages
 *
 * Purpose: Defines application routes and shared layout elements such as
 * header, footer and status toast.
 *
 * Rationale: React Router provides client-side navigation while global logging
 * tracks render flow. State is kept minimal (userId) to demonstrate passing
 * props between pages.
 */

import{useState,useEffect}from'react';import{BrowserRouter as Router,Routes,Route,useLocation}from'react-router-dom';import Header from'./shared/components/Header';import Footer from'./shared/components/Footer';import StatusToast from'./shared/components/StatusToast';import{SocketProvider}from'./shared/contexts/SocketContext';import HomePage from'./features/home/HomePage';import DocsPage from'./features/documentation/DocsPage';import TestPage from'./features/testing/TestPage';import AdminPage from'./features/admin/AdminPage';import AnalyticsPage from'./features/analytics/AnalyticsPage';import AdminUsersPage from'./features/adminUsers/AdminUsersPage';import AdminApiKeysPage from'./features/adminApiKeys/AdminApiKeysPage';import AdminPaymentEventsPage from'./features/adminPaymentEvents/AdminPaymentEventsPage';import NotFoundPage from'./shared/components/NotFoundPage';import LoginPage from'./features/auth/LoginPage'; // rationale: WebAuthn-gated login/register page
import ProtectedRoute from'./features/auth/ProtectedRoute'; // rationale: session-checks and redirects unauthenticated visitors to /login
import'./App.css';

const AppContent=()=>{
  const location=useLocation();
  const[userId,setUserId]=useState('testUser');
  useEffect(()=>{document.title=`QreditCharge - ${location.pathname}`;},[location.pathname]); // simple page focus tracking
  console.log(`AppContent is running with location: ${location.pathname}`);
  return(
    <div className="app">
      <Header/>
      <main id="main-content" tabIndex={-1}>
        <Routes>
          <Route path="/" element={<HomePage/>}/>
          <Route path="/docs" element={<DocsPage/>}/>
          <Route path="/test" element={<TestPage userId={userId} setUserId={setUserId}/>}/>
          <Route path="/login" element={<LoginPage/>}/> {/* public auth page — WebAuthn register/login */}
          <Route path="/admin" element={<ProtectedRoute><AdminPage/></ProtectedRoute>}> {/* protected: requires valid qryptauth session */}
            <Route path="users" element={<AdminUsersPage/>}/>
            <Route path="api-keys" element={<AdminApiKeysPage/>}/>
            <Route path="payment-events" element={<AdminPaymentEventsPage/>}/>
          </Route>
          <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage/></ProtectedRoute>}/> {/* protected: requires valid qryptauth session */}
          <Route path="*" element={<NotFoundPage/>}/>
        </Routes>
      </main>
      <Footer/>
      <StatusToast/>
    </div>
  );
};

const App=()=>{
    console.log('App is running');
    return(
        <SocketProvider userId="testUser">
            <Router>
                <AppContent/>
            </Router>
        </SocketProvider>
    );
};

export default App;
